import { Form } from 'factorial-form'

class CompanyIBAN extends Form {
  constructor(values: object) {
    super(values, {
      bank_account: 'string',
      swift: 'string',
    })
  }
}

export default CompanyIBAN
